import { useState } from "react";

const CustomTooltip = ({ children, content }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const [position, setPosition] = useState({ x: 0, y: 0 });

    const handleMouseEnter = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        setPosition({
            x: rect.left + rect.width / 2,
            y: rect.bottom + 6,         
        });
        setShowTooltip(true);
    };

    const handleMouseLeave = () => {
        setShowTooltip(false);
    };

    return (
        <div
            className="inline-block"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            {children}

            {showTooltip && (
                <div
                    className="fixed bg-black/80 text-white text-sm rounded px-3 py-2 shadow-lg z-[9999] -translate-x-1/2 whitespace-nowrap"
                    style={{
                        top: position.y,
                        left: position.x,
                    }}
                >
                    {content}
                </div>
            )}
        </div>
    );
};

export default CustomTooltip;